import axios from 'axios'
import {ResponseObject} from '../../../../../models'
import {ModuleModel, ObjectIdModule} from '../models'
const BASEURL = process.env.REACT_APP_DEV_API_HOTELERIA_URL

export async function deleteModuleService(dto: ObjectIdModule[]) {
  return await axios.delete<ResponseObject<ModuleModel>>(`${BASEURL}/module/deleteModule`, {
    data: dto,
  })
}
